import { useExperience } from '@cascade/react/experiences';
import { useI18n } from '@cascade/react/i18n';
import { Button, Card, Markdown, Text } from '@cascade/ui-library';
import { useNavigate } from 'react-router-dom';
import classes from './ExperienceConsent.module.scss';
import { Page } from '#components/page/index.ts';
import { HOME_PATH } from '#config/index.ts';

export const ExperienceConsent = () => {
  const { translate, translateError } = useI18n();
  const { experience, isAcceptingConsent, acceptConsentError, acceptConsent } =
    useExperience();

  const navigate = useNavigate();

  const consentText = experience?.consent_text ?? '';
  const errorMessage = acceptConsentError
    ? translateError(acceptConsentError)
    : undefined;

  const submitConsent = () => {
    acceptConsent().catch(() => undefined);
  };

  const navigateHome = () => navigate(HOME_PATH, { replace: true });

  return (
    <Page>
      <Card
        className={classes['experience-consent']}
        title={experience?.title}
        subtitle={experience?.description}
        padding='xl'
        borderRadius='xl'
      >
        <div className={classes.body}>
          <Text
            type='body-2'
            weight='medium'
            content={translate('experience.consent.prompt')}
          />
          <div className={classes.terms}>
            <Markdown content={consentText} />
          </div>
          {errorMessage ? (
            <Text
              type='body-2'
              color='text-danger'
              role='alert'
              content={errorMessage}
            />
          ) : null}
          <div className={classes.actions}>
            <Button
              variant='secondary'
              ghost
              label={translate('experience.home')}
              disabled={isAcceptingConsent}
              onClick={navigateHome}
            />
            <Button
              label={translate('experience.consent.accept')}
              disabled={isAcceptingConsent}
              onClick={submitConsent}
            />
          </div>
        </div>
      </Card>
    </Page>
  );
};
